module.exports = __webpack_public_path__ + "static/media/google.b018838b.svg";